/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Annotate_DescInputs */

const en_cad_features_annotate_desc = /** @type {(inputs: Cad_Features_Annotate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Associative linear, aligned, angular and radial dimensions, multileaders, tables, TrueType fonts, pick-point boundary hatching with islands, and blocks with attributes and nesting.`)
};

/**
* | output |
* | --- |
* | "Associative linear, aligned, angular and radial dimensions, multileaders, tables, TrueType fonts, pick-point boundary hatching with islands, and blocks with ..." |
*
* @param {Cad_Features_Annotate_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_annotate_desc = /** @type {((inputs?: Cad_Features_Annotate_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Annotate_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_annotate_desc(inputs)
});
export { cad_features_annotate_desc as "cad.features.annotate_desc" }